module.exports = __webpack_public_path__ + "img/addicon2.75c2408e.png";